export default __webpack_public_path__ + "img/ARA_security_perimeter_image.f4a82bff.jpg";